
import { AuthUser } from '@/types/auth';
import { toast } from '@/components/ui/use-toast';

/**
 * Load the user from localStorage if available
 */
export const loadStoredUser = (): AuthUser | null => {
  const storedUser = localStorage.getItem('authUser');
  if (storedUser) {
    try {
      const user = JSON.parse(storedUser);
      console.log("Loaded stored user:", user);
      return user;
    } catch (error) {
      console.error('Failed to parse stored user:', error);
      localStorage.removeItem('authUser');
    }
  }
  return null;
};

/**
 * Store user data in localStorage
 */
export const storeUser = (user: AuthUser): void => {
  localStorage.setItem('authUser', JSON.stringify(user));
  console.log("Stored user in localStorage:", user);
};

/**
 * Remove user data from localStorage
 */
export const removeStoredUser = (): void => {
  localStorage.removeItem('authUser');
  // Also clear any potential session storage that might be used
  sessionStorage.removeItem('authUser');
  console.log("Removed user from localStorage");
};
